import { Translate } from '@hooks/useI18n';

export const getAgencyColumn = (translate: Translate) => ({
  field: 'agency',
  label: translate('OPS_PORTAL.LABEL.AGENCY'),
});
